import AxiosRequest from '../axios';

// 登录
export const requestLogin = params =>
  AxiosRequest('/mgr/account/login', params, {});
// 切换用户租户
export const switchTenant = params =>
  AxiosRequest('/mgr/account/switch_tenant', params, {
    encrypt: true,
    method: 'POST'
  });
// 重置密码
export const adminResetPwd = params =>
  AxiosRequest('/mgr/account/adminreset', params, {
    encrypt: true,
    method: 'POST'
  });
// 用户修改密码
export const resetPwd = params =>
  AxiosRequest('/mgr/account/pwdreset', params, {
    encrypt: true,
    method: 'POST'
  });
// 根据用户名查询用户
export const searchUser = params =>
  AxiosRequest('/mgr/user/search', params, { encrypt: true });

// CRUD DEMO API
export const getDemoList = params =>
  AxiosRequest('/mgr/demo', params, { encrypt: true });
export const getDemo = params =>
  AxiosRequest('/mgr/demo/one', params, { encrypt: true });
export const addDemo = params =>
  AxiosRequest('/mgr/demo/add', params, { encrypt: true });
export const saveDemo = params =>
  AxiosRequest('/mgr/demo/save', params, { encrypt: true, method: 'POST' });
export const delDemo = params =>
  AxiosRequest('/mgr/demo/delete', params, { encrypt: true, method: 'POST' });

// 权限管理
export const getPermissionList = params =>
  AxiosRequest('/mgr/permission', params, { encrypt: true });
export const getPermission = params =>
  AxiosRequest('/mgr/permission/one', params, { encrypt: true });
export const addPermission = params =>
  AxiosRequest('/mgr/permission/add', params, { encrypt: true });
export const savePermission = params =>
  AxiosRequest('/mgr/permission/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const delPermission = params =>
  AxiosRequest('/mgr/permission/delete', params, {
    encrypt: true,
    method: 'POST'
  });

// 角色管理
export const getRoleList = params =>
  AxiosRequest('/mgr/role', params, { encrypt: true });
export const getRole = params =>
  AxiosRequest('/mgr/role/one', params, { encrypt: true });
export const addRole = params =>
  AxiosRequest('/mgr/role/add', params, { encrypt: true });
export const saveRole = params =>
  AxiosRequest('/mgr/role/save', params, { encrypt: true, method: 'POST' });
export const delRole = params =>
  AxiosRequest('/mgr/role/delete', params, { encrypt: true, method: 'POST' });

// 租户用户管理
export const getTenantUserList = params =>
  AxiosRequest('/mgr/tenantuser', params, { encrypt: true });
export const getTenantUser = params =>
  AxiosRequest('/mgr/tenantuser/one', params, { encrypt: true });
export const addTenantUser = params =>
  AxiosRequest('/mgr/tenantuser/add', params, { encrypt: true });
export const saveTenantUser = params =>
  AxiosRequest('/mgr/tenantuser/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const updateTenantUser = params =>
  AxiosRequest('/mgr/tenantuser/update', params, {
    encrypt: true,
    method: 'POST'
  });
export const delTenantUser = params =>
  AxiosRequest('/mgr/tenantuser/delete', params, {
    encrypt: true,
    method: 'POST'
  });
export const batchTenantUser = params =>
  AxiosRequest('/mgr/tenantuser/batchsave', params, {
    encrypt: true,
    method: 'POST'
  });

// 租户管理
export const getTenantList = params =>
  AxiosRequest('/mgr/tenant', params, { encrypt: true });
export const getTenant = params =>
  AxiosRequest('/mgr/tenant/one', params, { encrypt: true });
export const addTenant = params =>
  AxiosRequest('/mgr/tenant/add', params, { encrypt: true });
export const saveTenant = params =>
  AxiosRequest('/mgr/tenant/save', params, { encrypt: true, method: 'POST' });
export const updateTenant = params =>
  AxiosRequest('/mgr/tenant/update', params, { encrypt: true, method: 'POST' });
export const delTenant = params =>
  AxiosRequest('/mgr/tenant/delete', params, { encrypt: true, method: 'POST' });
export const setTenantSuper = params =>
  AxiosRequest('/mgr/tenant/setsuper', params, {
    encrypt: true,
    method: 'POST'
  });

// 租户权限管理
export const getTenantPermList = params =>
  AxiosRequest('/mgr/tenantperm', params, { encrypt: true });
export const getTenantPerm = params =>
  AxiosRequest('/mgr/tenantperm/one', params, { encrypt: true });
export const addTenantPerm = params =>
  AxiosRequest('/mgr/tenantperm/add', params, { encrypt: true });
export const saveTenantPerm = params =>
  AxiosRequest('/mgr/tenantperm/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const delTenantPerm = params =>
  AxiosRequest('/mgr/tenantperm/delete', params, {
    encrypt: true,
    method: 'POST'
  });

// 七牛云存储
export const getQiniuToken = params =>
  AxiosRequest('/api/qiniu/getuptoken', params, {});
export const getQiniuVideoToken = params =>
  AxiosRequest('/api/qiniu/getvideouptoken', params, {});
export const getKeepQiniuToken = params =>
  AxiosRequest('/api/qiniu/getkeepuptoken', params, {});

// 短信验证码模块
export const getAuthcodeList = params =>
  AxiosRequest('/api/authcode/list', params, { encrypt: true });

// 数据字典模块
export const getDictList = (type, params) =>
  AxiosRequest(`/mgr/dict/${type}`, params, { encrypt: true });
export const saveDict = (type, params) =>
  AxiosRequest(`/mgr/dict/${type}/save`, params, {
    encrypt: true,
    method: 'POST'
  });
export const delDict = (type, params) =>
  AxiosRequest(`/mgr/dict/${type}/delete`, params, {
    encrypt: true,
    method: 'POST'
  });
export const getDictCommonList = (type, params) =>
  AxiosRequest(`/mgr/dict/${type}/common`, params, { encrypt: true });

/* 以下为业务相关模块 */

// 目录模块
export const getCategory = (type, params) =>
  AxiosRequest(`/mgr/category/${type}`, params, { encrypt: true });
export const saveCategory = (type, params) =>
  AxiosRequest(`/mgr/category/${type}/save`, params, {
    encrypt: true,
    method: 'POST'
  });
export const delCategory = (type, params) =>
  AxiosRequest(`/mgr/category/${type}/delete`, params, {
    encrypt: true,
    method: 'POST'
  });

// 横幅模块
export const getBannerList = params =>
  AxiosRequest('/mgr/banner', params, { encrypt: true });
export const getBanner = params =>
  AxiosRequest('/mgr/banner/one', params, { encrypt: true });
export const getPageSkipList = params =>
  AxiosRequest('/mgr/banner/pageskip', params, { encrypt: true });
export const saveBanner = params =>
  AxiosRequest('/mgr/banner/save', params, { encrypt: true, method: 'POST' });
export const delBanner = params =>
  AxiosRequest('/mgr/banner/delete', params, { encrypt: true, method: 'POST' });
export const stickBanner = params =>
  AxiosRequest('/mgr/banner/stick', params, { encrypt: true, method: 'POST' });
export const updateBannerStatus = params =>
  AxiosRequest('/mgr/banner/updatestatus', params, {
    encrypt: true,
    method: 'POST'
  });

// 公告模块
export const getNoticeList = params =>
  AxiosRequest('/mgr/notice', params, { encrypt: true });
export const getNotice = params =>
  AxiosRequest('/mgr/notice/one', params, { encrypt: true });
export const saveNotice = params =>
  AxiosRequest('/mgr/notice/save', params, { encrypt: true, method: 'POST' });
export const delNotice = params =>
  AxiosRequest('/mgr/notice/delete', params, { encrypt: true, method: 'POST' });
export const stickNotice = params =>
  AxiosRequest('/mgr/notice/stick', params, { encrypt: true, method: 'POST' });
export const updateNoticeStatus = params =>
  AxiosRequest('/mgr/notice/updatestatus', params, {
    encrypt: true,
    method: 'POST'
  });

// 专栏
export const getColumnList = params =>
  AxiosRequest('/mgr/column', params, { encrypt: true });
export const getColumn = params =>
  AxiosRequest('/mgr/column/one', params, { encrypt: true });
export const saveColumn = params =>
  AxiosRequest('/mgr/column/save', params, { encrypt: true, method: 'POST' });
export const stickColumn = params =>
  AxiosRequest('/mgr/column/stick', params, { encrypt: true, method: 'POST' });
export const delColumn = params =>
  AxiosRequest('/mgr/column/delete', params, { encrypt: true, method: 'POST' });
// 资讯
export const getInfoList = params =>
  AxiosRequest('/mgr/column/info', params, { encrypt: true });
export const getInfo = params =>
  AxiosRequest('/mgr/column/info/one', params, { encrypt: true });
export const saveInfo = params =>
  AxiosRequest('/mgr/column/info/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const stickInfo = params =>
  AxiosRequest('/mgr/column/info/stick', params, {
    encrypt: true,
    method: 'POST'
  });
export const delInfo = params =>
  AxiosRequest('/mgr/column/info/delete', params, {
    encrypt: true,
    method: 'POST'
  });

// FAQ
export const getFaqList = params =>
  AxiosRequest('/mgr/faq', params, { encrypt: true });
export const getFaq = params =>
  AxiosRequest('/mgr/faq/one', params, { encrypt: true });
export const saveFaq = params =>
  AxiosRequest('/mgr/faq/save', params, { encrypt: true, method: 'POST' });
export const stickFaq = params =>
  AxiosRequest('/mgr/faq/stick', params, { encrypt: true, method: 'POST' });
export const delFaq = params =>
  AxiosRequest('/mgr/faq/delete', params, { encrypt: true, method: 'POST' });

// 消息模板
export const getMessageTemplateList = params =>
  AxiosRequest('/mgr/messagetemplate', params, { encrypt: true });
export const getMessageTemplate = params =>
  AxiosRequest('/mgr/messagetemplate/one', params, { encrypt: true });
export const saveMessageTemplate = params =>
  AxiosRequest('/mgr/messagetemplate/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const delMessageTemplate = params =>
  AxiosRequest('/mgr/messagetemplate/delete', params, {
    encrypt: true,
    method: 'POST'
  });

// 消息管理
export const getMessageList = params =>
  AxiosRequest('/mgr/message', params, { encrypt: true });

// 活动
export const getActivityList = params =>
  AxiosRequest('/mgr/activity', params, { encrypt: true });
export const getActivity = params =>
  AxiosRequest('/mgr/activity/one', params, { encrypt: true });
export const saveActivity = params =>
  AxiosRequest('/mgr/activity/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const stickActivity = params =>
  AxiosRequest('/mgr/activity/stick', params, {
    encrypt: true,
    method: 'POST'
  });
export const getActivityUserList = params =>
  AxiosRequest('/mgr/activity/user', params, { encrypt: true });
export const delActivity = params =>
  AxiosRequest('/mgr/activity/delete', params, {
    encrypt: true,
    method: 'POST'
  });
// 开放区域管理
export const getOpeningRegionList = params =>
  AxiosRequest('/mgr/openingregion', params, { encrypt: true });
export const getOpeningRegion = params =>
  AxiosRequest('/mgr/openingregion/one', params, { encrypt: true });
export const saveOpeningRegion = params =>
  AxiosRequest('/mgr/openingregion/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const delOpeningRegion = params =>
  AxiosRequest('/mgr/openingregion/delete', params, {
    encrypt: true,
    method: 'POST'
  });

// 空间租户管理
export const getSpaceList = params =>
  AxiosRequest('/mgr/space', params, { encrypt: true });
export const createSpace = params =>
  AxiosRequest('/mgr/space/create', params, {
    encrypt: true,
    method: 'POST'
  });
export const getSpace = (tenantType, params) =>
  AxiosRequest(`/mgr/space/${tenantType}/one`, params, { encrypt: true });
export const saveSpace = (tenantType, params) =>
  AxiosRequest(`/mgr/space/${tenantType}/save`, params, {
    encrypt: true,
    method: 'POST'
  });
export const setSpaceSuper = params =>
  AxiosRequest('/mgr/space/setsuper', params, {
    encrypt: true,
    method: 'POST'
  });
// 空间信息
export const getMySpace = params =>
  AxiosRequest('/mgr/space/my', params, { encrypt: true });
// 空间资源
export const getSpaceResListAll = params =>
  AxiosRequest('/mgr/spaceres/list', params, { encrypt: true });
export const getSpaceRes = params =>
  AxiosRequest('/mgr/spaceres/one', params, { encrypt: true });
export const saveSpaceRes = params =>
  AxiosRequest('/mgr/spaceres/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const delSpaceRes = params =>
  AxiosRequest('/mgr/spaceres/delete', params, {
    encrypt: true,
    method: 'POST'
  });
export const updateSpaceRes = params =>
  AxiosRequest('/mgr/spaceres/update', params, {
    encrypt: true,
    method: 'POST'
  });
// 团队
export const getTeamList = params =>
  AxiosRequest('/mgr/team', params, { encrypt: true });
export const getTeamMember = params =>
  AxiosRequest('/mgr/team/member', params, { encrypt: true });

// 商品管理
export const getItemList = params =>
  AxiosRequest('/mgr/item', params, { encrypt: true });
export const getItem = params =>
  AxiosRequest('/mgr/item/one', params, { encrypt: true });
export const saveItem = params =>
  AxiosRequest('/mgr/item/save', params, { encrypt: true, method: 'POST' });
export const delItem = params =>
  AxiosRequest('/mgr/item/delete', params, { encrypt: true, method: 'POST' });
export const updateItemStatus = params =>
  AxiosRequest('/mgr/item/updatestatus', params, {
    encrypt: true,
    method: 'POST'
  });
export const updateItemCover = params =>
  AxiosRequest('/mgr/item/updatecover', params, {
    encrypt: true,
    method: 'POST'
  });
export const batchItem = params =>
  AxiosRequest('/mgr/item/batchsave', params, {
    encrypt: true,
    method: 'POST'
  });

// 订单管理
export const getOrderList = params =>
  AxiosRequest('/mgr/order', params, { encrypt: true });
export const getOrder = (type, params) =>
  AxiosRequest(`/mgr/order/${type}/one`, params, { encrypt: true });
export const updateStatusOrder = params =>
  AxiosRequest('/mgr/order/updatestatus', params, {
    encrypt: true,
    method: 'POST'
  });
export const toDispatchOrder = params =>
  AxiosRequest('/mgr/order/todispatch', params, {
    encrypt: true,
    method: 'POST'
  });
export const delOrder = params =>
  AxiosRequest('/mgr/order/delete', params, {
    encrypt: true,
    method: 'POST'
  });

// 退款模块
export const getRefundList = params =>
  AxiosRequest('/mgr/refund', params, { encrypt: true });
export const getRefund = (type, params) =>
  AxiosRequest(`/mgr/refund/${type}/one`, params, { encrypt: true });
export const updateRefundStatus = params =>
  AxiosRequest('/mgr/refund/updatestatus', params, {
    encrypt: true,
    method: 'POST'
  });
export const rushRefundMent = params =>
  AxiosRequest('/mgr/refund/rushrefundment', params, {
    encrypt: true,
    method: 'POST'
  });
export const rushRefundGood = params =>
  AxiosRequest('/mgr/refund/rushrefundgood', params, {
    encrypt: true,
    method: 'POST'
  });
export const refundMent = params =>
  AxiosRequest('/mgr/refund/refundment', params, {
    encrypt: true,
    method: 'POST'
  });
export const readyRefundApply = params =>
  AxiosRequest('/mgr/refund/ready', params, { encrypt: true });
export const submitRefundApply = params =>
  AxiosRequest('/mgr/refund/apply', params, { encrypt: true, method: 'POST' });
// 房间
export const getRoomList = (type, params) =>
  AxiosRequest(`/mgr/room/${type}`, params, { encrypt: true });
export const getRoomListCommon = params =>
  AxiosRequest(`/mgr/room/common`, params, { encrypt: true });
export const getRoom = (type, params) =>
  AxiosRequest(`/mgr/room/${type}/one`, params, { encrypt: true });
export const saveRoom = (type, params) =>
  AxiosRequest(`/mgr/room/${type}/save`, params, {
    encrypt: true,
    method: 'POST'
  });
export const delRoom = (type, params) =>
  AxiosRequest(`/mgr/room/${type}/delete`, params, {
    encrypt: true,
    method: 'POST'
  });
export const saveActiveState = (type, params) =>
  AxiosRequest(`/mgr/room/${type}/activestate`, params, {
    encrypt: true,
    method: 'POST'
  });
// 房间资源管理
export const getRoomResListAll = params =>
  AxiosRequest('/mgr/roomres/list', params, { encrypt: true });
export const getRoomRes = params =>
  AxiosRequest('/mgr/roomres/one', params, { encrypt: true });
export const saveRoomRes = params =>
  AxiosRequest('/mgr/roomres/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const delRoomRes = params =>
  AxiosRequest('/mgr/roomres/delete', params, {
    encrypt: true,
    method: 'POST'
  });
// 租赁单管理
export const getRoomLeaseRecordList = (tenantType, params) =>
  AxiosRequest(`/mgr/roomleaserecord/${tenantType}`, params, {
    encrypt: true
  });
export const cancelRoomOrder = params =>
  AxiosRequest('/mgr/roomleaserecord/cancel', params, {
    encrypt: true,
    method: 'POST'
  });
export const saveRoomLeaseRecord = params =>
  AxiosRequest('/mgr/roomleaserecord/save', params, {
    encrypt: true,
    method: 'POST'
  });
export const getRoomLeaseRecord = (tenantType, params) =>
  AxiosRequest(`/mgr/roomleaserecord/${tenantType}/one`, params, {
    encrypt: true
  });
export const receiveLeaseOrderMoney = params =>
  AxiosRequest('/mgr/roomleaserecord/receivemoney', params, {
    encrypt: true,
    method: 'POST'
  });
// 租赁售后
export const getRoomLeaseRefundList = (tenantType, params) =>
  AxiosRequest(`/mgr/roomleaserefundrecord/${tenantType}`, params, {
    encrypt: true
  });
export const getRoomLeaseRefundRecord = (tenantType, params) =>
  AxiosRequest(`/mgr/roomleaserefundrecord/${tenantType}/one`, params, {
    encrypt: true
  });
export const roomLeaseArtificialRefund = params =>
  AxiosRequest('/mgr/roomleaserefundrecord/artificial/refund', params, {
    encrypt: true,
    method: 'POST'
  });
export const roomLeaseOnlineRefund = params =>
  AxiosRequest('/mgr/roomleaserefundrecord/online/refund', params, {
    encrypt: true,
    method: 'POST'
  });
export const verifyLeaseRefundRecord = params =>
  AxiosRequest('/mgr/roomleaserefundrecord/verify', params, {
    encrypt: true,
    method: 'POST'
  });

// 空间评价
export const getRoomRateList = params =>
  AxiosRequest('/mgr/roomrate', params, { encrypt: true });
export const saveRoomRateActive = params =>
  AxiosRequest('/mgr/roomrate/active', params, {
    encrypt: true,
    method: 'POST'
  });

// 对账单
export const getStatementList = (tenantType, params) =>
  AxiosRequest(`/mgr/statement/${tenantType}`, params, { encrypt: true });
export const settleStatement = params =>
  AxiosRequest(`/mgr/statement//settle`, params, {
    encrypt: true,
    method: 'POST'
  });

// 对账单交易明细
export const getStatementTransactionList = (type, params) =>
  AxiosRequest(`/mgr/transaction/${type}/statement`, params, { encrypt: true });

// 交易明细
export const getTransactionList = params =>
  AxiosRequest(`/mgr/transaction`, params, { encrypt: true });

// 租户选择组件查询方法
export const getTenantCommonList = (tenantType, params) =>
  AxiosRequest(`/mgr/tenant/${tenantType}/common/list`, params, {
    encrypt: true
  });

// 店铺管理
export const getShopList = params =>
  AxiosRequest('/mgr/shop', params, { encrypt: true });
export const getShop = params =>
  AxiosRequest('/mgr/shop/one', params, { encrypt: true });
export const saveShop = params =>
  AxiosRequest('/mgr/shop/save', params, { encrypt: true, method: 'POST' });
export const setShopSuper = params =>
  AxiosRequest('/mgr/shop/setsuper', params, {
    encrypt: true,
    method: 'POST'
  });

// 发票管理
export const getInvoiceList = params =>
  AxiosRequest('/mgr/invoice', params, { encrypt: true });
export const getInvoice = params =>
  AxiosRequest('/mgr/invoice/one', params, { encrypt: true });
export const verifyInvoice = params =>
  AxiosRequest('/mgr/invoice/verify', params, {
    encrypt: true,
    method: 'POST'
  });
